module.exports = __webpack_public_path__ + "static/img/headset.2987212.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/headset.png
// module id = 6u3a
// module chunks = 96